<template>
    <v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="User profile"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <!-- AVATAR -->
        <div class="d-flex justify-center pt-0" v-if="loaded">
            <UserAvatar :photo="item.photo" size="120px" class="elevation-3" style="z-index: 10"/>
        </div> 

        <!-- ALL -->
        <v-card max-width="620px" outlined class="mx-auto" style="margin-top:-70px" v-if="loaded">
            <div :style="{backgroundColor: item.color}">

                <v-img height="170px" :src="require('@/assets/textures/'+item.texture+'A.png')">
                    <div class="headline font-weight-medium text-center white--text" style="padding-top:84px">{{item.name}}</div>
                    
                    <div class="d-flex justify-center align-center white--text">
                        <div class="subtitle-1 text-center" style="line-height:1.2" >
                            <span v-if="item.bio">{{item.bio}}</span>
                            <span v-else style="opacity:.5"><i>- Personal slogan missing -</i></span>
                        </div>
                    </div> 
                </v-img> 
            </div>  

            <!-- STATS -->
            <!-- <div v-if="item.role.student && (user.role.captain || user.role.director || user.role.master)">
                <Stats :metrics="item.metrics" />
                <v-divider></v-divider>
            </div> -->

            <!-- AWARDS -->
            <!-- <v-row v-if="item.role.student">
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center mt-8 font-weight-medium black--text" style="font-size:11px">MY AWARDS</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-6 pb-8 px-4">
                    <v-row v-if="awards.length>0">
                        <v-col cols="12" sm="4" v-for="aw in awards" :key="aw.id" class="d-flex align-center">
                            <v-img :src="require('@/assets/awards/' + aw + '.png')" contain height="64px"></v-img>
                        </v-col>
                    </v-row>
                    
                    <div class="caption font-weight-medium grey--text mt-5 ml-4" v-else>NO AWARDS YET</div>
                </v-col>
            </v-row>

            <v-divider></v-divider> -->

             <!-- AWARDS -->
            <v-row v-if="item.role.student">
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-10" style="font-size:11px">MY AWARDS</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="py-6 px-4">
                    <v-row>
                        <v-col cols="12" sm="3" v-for="aw in stampsAwards" :key="aw.id" class="d-flex align-center">
                            <v-img class="over-icon" :src="require('@/assets/awards/' + aw + '.png')" contain height="48px" v-if="item.awards[aw]"></v-img>
                            <v-img class="over-icon" :src="require('@/assets/awards/stamps/' + aw + '.png')" contain height="48px" v-else></v-img>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- BADGES -->
            <v-row v-if="item.role.student">
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-10" style="font-size:11px">MY BADGES</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="py-6 px-4">
                    <v-row>
                        <v-col cols="12" sm="3" v-for="aw in stampsBadges" :key="aw.id" class="d-flex align-center">
                            <v-img class="over-icon" :src="require('@/assets/awards/' + aw + '.png')" contain height="48px" v-if="item.awards[aw]"></v-img>
                            <v-img class="over-icon" :src="require('@/assets/awards/stamps/' + aw + '.png')" contain height="48px" v-else></v-img>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- ATTRIBUTES -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-4" style="font-size:11px">MY MOLECULE</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="px-4 pb-6">
                    <div class="d-flex justify-space-between">
                        <div class="pl-4 pt-4">
                            <div v-if="attributes.length>0">
                                <div v-for="(att, index) in attributes" :key="att.id">
                                    <span class="mr-1 body-1 font-weight-medium" :style="{color: item.color}">{{index+1}}.</span>
                                    <span class="black--text">{{att}}</span>
                                </div>
                            </div>
                            <div class="caption font-weight-medium grey--text" v-else>NO ATTRIBUTES YET</div>

                            <div class="mt-1" v-if="attributes.length>0">
                                <v-btn text class="ml-n4" :style="{color: item.color}" @click="$router.push('/mc/'+item.uid)">
                                    Visit my molecule
                                    <v-icon right size="14px" :color="item.color">fa-external-link-alt</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <div class="pr-12 mt-6" @click="$router.push('/mc/'+item.uid)" style="cursor:pointer">
                            <v-img :src="require('@/assets/molecule/molecule-center.png')" width="110px"></v-img>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- MAP OF LIFE -->
            <v-row v-if="!user.role.student">
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-4" style="font-size:11px">MY LIFE MAP</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="px-4 pb-6">
                    <div class="mt-1 pl-4">
                        <v-btn text class="ml-n4" :style="{color: item.color}" @click="$router.push('/map-of-life/'+item.uid)">
                            Visit my map of life
                            <v-icon right size="14px" :color="item.color">fa-external-link-alt</v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider v-if="!user.role.student"></v-divider>

            <!-- REPUTATION PLANNER -->
            <v-row v-if="item.role.student">
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-5" style="font-size:11px">MY REPUTATION PLANNER</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-5 pb-4 pl-4 pr-6">
                    <v-btn text class="ml-n1" :style="{color: item.color}" @click="$router.push('/planner/p/'+item.uid)">
                        Go to my reputation planner
                        <v-icon right size="14px" :color="item.color">fa-external-link-alt</v-icon>
                    </v-btn>
                    <div class="caption grey--text ml-4 mt-n2">Not visible for other students</div>
                </v-col>
            </v-row>

            <v-divider v-if="item.role.student"></v-divider> 

            <!-- TOP 3 -->
            <v-row v-if="item.role.student">
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-5" style="font-size:11px">MY TOP 3</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-5 pb-4 pl-4 pr-6">
                    <Top3 :item="item" @reinit="reInit" />
                </v-col>
            </v-row>

            <v-divider v-if="item.role.student"></v-divider> 

            <!-- TEAM -->
            <v-row v-if="item.role.student && item.team != null">
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center mt-7 font-weight-medium black--text" style="font-size:11px">MY TEAM</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="py-6 px-6">
                    <div class="d-flex align-center">
                        <v-avatar left class="elevation-1" size="60px">
                            <img :src="team.photo.url" v-if="team.photo != null">
                            <img src="@/assets/group-default.png" v-else>
                        </v-avatar>
                        <div>
                            <div class="black--text body-1 ml-3">{{team.name}}</div>
                            <v-btn text class="ml-n1 mt-n3" :style="{color: item.color}" @click="$router.push('/team/'+team.id)">
                                Visit the team
                                <v-icon right size="14px" :color="item.color">fa-external-link-alt</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-divider v-if="user.role.student"></v-divider>

            <!-- PDA -->
            <template v-if="!user.role.student">
                <v-row>
                    <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                        <div class="text-center font-weight-medium black--text pt-3 pb-2" style="font-size:11px">
                            <div>MY PERSONAL</div>
                            <div>DEVELOPMENT</div>
                            <div>ANALYSIS</div>
                        </div>
                    </v-col>
                    <v-col col="12" sm="6" md="8" class="pt-8 pb-8 px-4">
                        <div class="pl-4">
                            <v-btn depressed :color="item.color" class="white--text" v-if="item.pda" target="_blank" :href="item.pda">
                                <v-icon small class="mr-4">fa-cloud-download-alt</v-icon>
                                Downlad PDA
                            </v-btn>
                            <div class="body-2 mt-1 grey--text text--darken-1" v-if="!item.pda">PDA is not uploaded yet.</div>
                        </div>
                    </v-col>
                </v-row>

                <v-divider></v-divider>
            </template>

            <!-- EMAIL AND LINKEDIN -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center mt-4 font-weight-medium black--text" style="font-size:11px">MY CONTACT</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="py-6 px-6">
                    <div class="text-center">
                        <div class="d-flex align-center">
                            <v-chip outlined pill>
                                <v-avatar left class="primary">
                                    <v-icon size="12px" color="white">fa-envelope</v-icon>
                                </v-avatar>
                                
                                <span class="caption mr-2">{{item.email}}</span>
                            </v-chip>
                        </div>

                        <!-- <div class="d-flex align-center mt-4">
                            <v-btn depressed class="white--text" color="#0e76a8" style="text-transform:none" :disabled="item.linkedin==undefined" :href="item.linkedin" target="_blank">
                                Take a look at my <v-icon small color="white" class="ml-2">fab fa-linkedin</v-icon>
                            </v-btn>
                        </div> -->
                    </div>
                </v-col>
            </v-row>
        </v-card>

        <!-- GIVER -->
        <Giver 
            :item="item"
            @awardssaved="reInit"
            @pdasaved="reInit"
            class="mx-auto mt-6 mb-10" 
            v-if="(user.role.director || user.role.master)  && loaded" />

        <!-- LOADER -->
        <SendingLoader v-if="!loaded"/>
    </v-card>
</template>

<script>
import Metrics from '@/services/metrics'
import Stats from '@/components/profile/Stats'
import Users from '@/firebase/users'
import Teams from '@/firebase/teams'
import Giver from '@/components/profile/Giver'
import Top3 from '@/components/profile/Top3'

export default {
    data: () => ({
        loaded: false,
        item: null,
        awards: [],
        attributes: [],
        team: null,
        stampsAwards: [
            'topProspect',
            'badgeEnergy',
            'bestLifeMap',
            'linkedin',
            '3StepsSkillsPath'
        ],
        stampsBadges: [
            'profile',
            'molecule',
            'lifeMap',
            'top3',
            'reputationPlanner'
        ]
    }),
    components: {
        Giver,
        Top3,
        Stats
    },
    mounted() {
        this.init();
    },
    methods: {
        reInit() {
            this.awards = [];
            this.attributes = [];
            this.loaded =  false;
            this.init();
        },
        init() {
            Users.get(this.$route.params.id)
                    .then(response => {
                        if (response.status === true) {
                            this.item = response.doc.data();
                            this.item.uid = response.doc.id;
                            this.item.metrics = Metrics.get(this.item);
                            if (this.item.awards && Object.keys(this.item.awards).length > 0) {
                                this.setAwards();
                            }
                            if (this.item.attributes && Object.keys(this.item.attributes).length > 0) {
                                this.setAttributes();
                            }
                            if (this.item.role.student && this.item.team != null) {
                                this.getTeam();
                            } else {
                                this.loaded = true;
                            }
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                    });
        },
        getTeam() {
            Teams.get(this.item.team)
                    .then(response => {
                        if (response.status === true) {
                            this.team = response.doc.data();
                            this.team.id = response.doc.id;
                            this.team.str = this.team.group.day + ' / ' + this.team.group.hour;
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        setAwards() {
            for(let key in this.item.awards) {
                this.awards.push(key)
            }

            let actualPos = null;
            let newPos = null;

            this.awards.forEach( (dt, index) => {
                if (dt == 'topProspect') {
                    actualPos = index;
                    newPos = 0;
                }
            });
            this.awards = this.arrayMove(this.awards, actualPos, newPos);
        },
        setAttributes() {
            let tempo = [];
            for(let key in this.item.attributes) {
                tempo.push(this.item.attributes[key])
            }

            this.attributes = tempo;
        },
        arrayMove (arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        }
    }
}
</script>